<template>
  <div ref="projectReadmeContainer" class="c-project__readme-container u-mts">
    <template v-if="isReadmeInRepo">
      <p v-if="getRepo.loading" class="c-message u-mbm">{{ t('loading') }}</p>
      <p v-else-if="getRepo.err" class="c-message u-mbm">{{ t('error') }}</p>
      <template v-else-if="getRepo.data">
        <h2 class="c-heading__title">Readme</h2>
        <Readme :html="getRepo.data.readme.html" />
      </template>
    </template>
    <template v-else>
      <h2 class="c-heading__title">Readme</h2>
      <Readme :html="readmeCmsContent" />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import { useRepositoryContext } from '@/contexts/ProjectContext'
import Readme from '@/components/Readme.vue'
import { useI18n } from '@/utils/i18n'
import { marked } from 'marked'
import DOMPurify from 'dompurify'

const props = defineProps<{
  hasReadme: string
  readmeContent: string
}>()

const getRepo = computed(() => useRepositoryContext())

// README
const isReadmeInRepo = ref(false)
if (props.hasReadme === 'True') {
  isReadmeInRepo.value = true
} else {
  isReadmeInRepo.value = false
}

const readmeCmsContent = ref(DOMPurify.sanitize(marked(props.readmeContent), { ADD_TAGS: [ 'iframe' ], ADD_ATTR: [ 'src', 'width', 'height', 'allowfullscreen' ] }))

const projectReadmeContainer = ref<HTMLElement>()

onMounted(() => {
  console.log('REPO: ', getRepo.value)
  console.log('HAS README: ', props.hasReadme)
  console.log('isReadmeInRepo: ', isReadmeInRepo.value)
})

const { t } = useI18n({
  messages: {
    fr: {
      loading: 'Chargement du README',
      error: 'Une erreur est survenue lors du chargement du README'
    },
    en: {
      loading: 'Loading the project README...',
      error: 'An error occurred while trying to load this project README.'
    }
  }
})
</script>
